import { createAction, handleActions } from 'redux-actions';
import { call, put, takeLatest } from 'redux-saga/effects';
import { requestDMPost } from 'modules/fetch/api';

const SEND_COMPLAINT_SEARCH = 'sendComplaintSearch/SEND_COMPLAINT_SEARCH';
const COMPLAINT_SEARCH_RESULT = 'sendComplaintSearch/COMPLAINT_SEARCH_RESULT';

export const sendComplaintSearch = createAction(SEND_COMPLAINT_SEARCH);

export function* sendComplaintSearchaction(action) {
  try {
    if (action.payload.status !== 'stop') {
      const instr = `민원 결과 조회 → ${action.payload.searchId ? `접수번호 : ${action.payload.searchId}, ` : ''}
      ${action.payload.call ? `연락처 : ${action.payload.call}, ` : ''}`;

      const paramSet = {
        user_id: sessionStorage.getItem('user_id'),
        in_type: 'query',
        in_str: instr,
        session_id: sessionStorage.getItem('session_id'),
        channel_id: sessionStorage.getItem('device'),
        parameters: { complaint_search: JSON.stringify(action.payload) },
      };

      const response = yield call(requestDMPost, paramSet);
      const getComplaint = response.data.data?.result?.fulfillment?.messages || [];

      let result = [];
      let resultData = [];
      if (getComplaint.length > 0) {
        result = getComplaint[0].items[0].value.value || '300';

        if (result === '200') {
          resultData = JSON.parse(getComplaint[0].items[0].result_data.value);
        } else {
          resultData = '';
        }
      }

      yield put({
        type: COMPLAINT_SEARCH_RESULT,
        payload: {
          result: result || [],
          resultData: resultData || [],
          msg: response.data.data.result.fulfillment.speech,
        },
      });
    } else {
      yield put({
        type: COMPLAINT_SEARCH_RESULT,
        payload: {
          result: 0,
          resultData: [],
        },
      });
    }
  } catch (error) {
    yield put({
      type: COMPLAINT_SEARCH_RESULT,
      payload: {
        result: 100,
        resultData: [],
      },
    });
  }
}

export function* sendComplaintSearchSaga() {
  yield takeLatest(SEND_COMPLAINT_SEARCH, sendComplaintSearchaction);
}

const initialState = {
  result: [],
  resultData: [],
};

export default handleActions(
  {
    [COMPLAINT_SEARCH_RESULT]: (state, action) => ({
      ...state,
      result: action.payload.result,
      resultData: action.payload.resultData,
      msg: action.payload.msg,
    }),
  },
  initialState
);
